import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/UnitList.css";

const RoomList = () => {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "" });
  const [deleteModal, setDeleteModal] = useState({ show: false, room: null });
  const API_URL = process.env.REACT_APP_API_URL || "";

  useEffect(() => {
    const apiUrl = `${API_URL}room-list.php`;
    fetch(apiUrl)
      .then((res) => res.json())
      .then((response) => {
        if (response.status === "success" && Array.isArray(response.data)) {
          setRooms(response.data);
        } else {
          showToast("Failed to load rooms", "error");
        }
      })
      .catch(() => showToast("Error fetching data from the server", "error"));
  }, [API_URL]);

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "" });
    }, 3000);
  };

  const filteredRooms = rooms.filter((room) =>
    room.room_no.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleEdit = (room) => {
    navigate("/add-room", { state: { room, isEditing: true } });
    showToast(`Editing room: ${room.room_no}`, "info");
  };

  const handleDelete = async (roomId) => {
    const roomToDelete = rooms.find((room) => room.id === roomId);
    setDeleteModal({ show: true, room: roomToDelete });
  };

  const confirmDelete = async () => {
    const { room } = deleteModal;
    try {
      const response = await fetch(`${API_URL}room-delete.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: room.id }),
      });

      const data = await response.json();

      if (data.status === "success") {
        showToast(
          `Room "${room.room_no}" deleted successfully`,
          "success"
        );
        setRooms((prevRooms) =>
          prevRooms.filter((roomItem) => roomItem.id !== room.id)
        );
      } else {
        showToast(data.message || "Failed to delete room", "error");
      }
    } catch (error) {
      showToast("Network error. Could not delete room.", "error");
    }
    setDeleteModal({ show: false, room: null });
  };

  const cancelDelete = () => {
    setDeleteModal({ show: false, room: null });
  };

  const handleAddRoom = () => {
    navigate("/add-room");
  };

  return (
    <div className="category-list-content">
      <div className="page-header">
        <div className="header-content">
          <h1>Room Management</h1>
          <p>Manage all available rooms</p>
        </div>
        <button className="add-unit-button" onClick={handleAddRoom}>
          + Add New Room
        </button>
      </div>

      <div className="filters-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by room number..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="unit-list-table-container">
        <table className="unit-list-table">
          <thead>
            <tr>
              <th>Room Number</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredRooms.map((room) => (
              <tr key={room.id}>
                <td>
                  <div className="unit-info">
                    <div className="unit-icon">🚪</div>
                    <span>{room.room_no}</span>
                  </div>
                </td>
                <td>{new Date(room.created_at).toLocaleString()}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="action-btn edit"
                      onClick={() => handleEdit(room)}
                    >
                      Edit
                    </button>
                    <button
                      className="action-btn delete"
                      onClick={() => handleDelete(room.id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="table-footer">
        <div className="results-info">
          Showing {filteredRooms.length} of {rooms.length} rooms
        </div>
      </div>

      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button
              className="toast-close"
              onClick={() => setToast({ show: false, message: "", type: "" })}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteModal.show && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Confirm Delete</h3>
            </div>
            <div className="modal-body">
              <p>
                Are you sure you want to delete room{" "}
                <strong>"{deleteModal.room?.room_no}"</strong>?
              </p>
              <p>This action cannot be undone.</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={cancelDelete}>
                No, Cancel
              </button>
              <button className="btn btn-danger" onClick={confirmDelete}>
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RoomList;
